export function parseFlagEnumValues(number: number | null | undefined): number[] {
    if (number == null || !Number.isFinite(number) || number <= 0 || !Number.isInteger(number)) return [];

    const result: number[] = [];
    for (let i = 0; number > 0; i++) {
        // eslint-disable-next-line no-bitwise
        const indexBit = number & 1;
        // eslint-disable-next-line no-bitwise
        if (indexBit) result.push(1 << i);
        // eslint-disable-next-line no-bitwise, no-param-reassign
        number >>= 1;
    }

    return result;
}
